// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__qg3XO","savePackageButton":"ClientWallet_savePackageButton__1HwbA"};